import { Button } from '@givebutter/primitives/button';
import { useToast } from '@givebutter/primitives/toast';
import { faCopy } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCopy } from 'components/snippet';
import { Campaign } from 'types/domain';

interface CopyCampaignCodeProps {
    campaign: Campaign;
}

const CopyCampaignCode = ({ campaign }: CopyCampaignCodeProps) => {
    const { success } = useToast();
    const { onClickCopy } = useCopy({
        onCopy: () => success('Campaign link has been copied to clipboard'),
    });

    return (
        <Button
            variant="transparent"
            color="neutral"
            onClick={e => onClickCopy(e, campaign.url)}
            size="sm"
            shape="square"
            className={'hover:bg-gray-300'}
            aria-label="Copy"
        >
            <FontAwesomeIcon icon={faCopy} />
        </Button>
    );
};

export { CopyCampaignCode };
